var moment = module.exports = require("./moment-timezone");
moment.tz.load(require('./data/packed/latest.json'));



//////////////////
// WEBPACK FOOTER
// /app/~/moment-timezone/index.js
// module id = ../../../../moment-timezone/index.js
// module chunks = 18